import { Component, inject, Input, OnInit } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss']
})
export class ConfirmPopUpComponent implements OnInit {
  @Input() title: string;
  @Input() eventBroadcast: string;
  readonly nzModalData: any = inject(NZ_MODAL_DATA);

  ngOnInit() {
    this.title = this.nzModalData.title;
    this.eventBroadcast = this.nzModalData.eventBroadcast;
  }
}
